export default __webpack_public_path__ + "static/media/tick_icon.3603a8a8.svg";